import { UserSettingRouteKey } from '@/constants/setting';
import {
  BankOutlined,
  BarChartOutlined,
  DeploymentUnitOutlined,
  DollarOutlined,
  LockOutlined,
  LogoutOutlined,
  MonitorOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  WalletOutlined,
} from '@ant-design/icons';

export const UserSettingIconMap = {
  [UserSettingRouteKey.Profile]: <UserOutlined style={{ fontSize: 24 }} />,
  [UserSettingRouteKey.Password]: <LockOutlined style={{ fontSize: 24 }} />,
  [UserSettingRouteKey.Model]: (
    <DeploymentUnitOutlined style={{ fontSize: 24 }} />
  ),
  [UserSettingRouteKey.System]: <MonitorOutlined style={{ fontSize: 24 }} />,
  [UserSettingRouteKey.Logout]: (
    <LogoutOutlined color="red" style={{ fontSize: 24, color: 'red' }} />
  ),
  // [UserSettingRouteKey.BotzillaAdmin]: <IdcardOutlined />,
  [UserSettingRouteKey.CompanyCreateUser]: (
    <UsergroupAddOutlined style={{ fontSize: 24 }} />
  ),
  [UserSettingRouteKey.CompanyTokens]: (
    <DollarOutlined style={{ fontSize: 24 }} />
  ),
  [UserSettingRouteKey.AdminTokens]: (
    <BarChartOutlined style={{ fontSize: 24 }} />
  ),
  [UserSettingRouteKey.CreateCompany]: (
    <BankOutlined style={{ fontSize: 24 }} />
  ),
  [UserSettingRouteKey.BotzillaPackages]: (
    <WalletOutlined style={{ fontSize: 24 }} />
  ),
  // [UserSettingRouteKey.Team]: (
  //   <TeamOutlined style={{ color: 'black', fontSize: 24 }} />
  // ),
  // [UserSettingRouteKey.Api]: <ApiIcon style={{ fontSize: 24 }} />,
};

export * from '@/constants/setting';

export const LocalLlmFactories = ['Infomaniak', 'vLLM', 'OpenAI']; //'Xinference'
export enum TenantRole {
  Owner = 'owner',
  Invite = 'invite',
  Normal = 'normal',
}
